var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFt08(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0605469 30.4386C0.0605469 13.6281 13.6886 0 30.4991 0C47.3017 0.0190426 60.9186 13.636 60.9377 30.4386C60.9377 47.2491 47.3096 60.8771 30.4991 60.8771C13.6886 60.8771 0.0605469 47.2491 0.0605469 30.4386ZM3.10412 30.4386C3.10412 45.5682 15.3695 57.8331 30.4991 57.8331C45.6218 57.8164 57.8769 45.5612 57.8936 30.4386C57.8936 15.3089 45.6287 3.04404 30.4991 3.04404C15.3695 3.04404 3.10412 15.3089 3.10412 30.4386ZM35.2615 19.6594C38.7667 19.6632 41.6076 22.4493 41.6114 25.8868C41.6051 27.6822 40.8043 29.3865 39.4168 30.5571C40.8174 31.7411 41.6192 33.4672 41.6114 35.2807C41.5964 38.7054 38.7536 41.47 35.2615 41.4553V43.0123C35.2615 43.8717 34.5508 44.5687 33.6739 44.5687C32.7971 44.5687 32.0863 43.8717 32.0863 43.0123V41.4553H28.9112V43.0123C28.9112 43.8717 28.2005 44.5687 27.3241 44.5687C26.4472 44.5687 25.7365 43.8717 25.7365 43.0123V41.4553H20.9742C20.0973 41.4553 19.3866 40.7583 19.3866 39.8984C19.3866 39.0389 20.0973 38.3419 20.9742 38.3419H22.5613V22.7733H20.9742C20.0973 22.7733 19.3866 22.0763 19.3866 21.2164C19.3866 20.3564 20.0973 19.6594 20.9742 19.6594H25.7365V18.103C25.7365 17.243 26.4472 16.546 27.3241 16.546C28.2005 16.546 28.9112 17.243 28.9112 18.103V19.6594H32.0863V18.103C32.0863 17.243 32.7971 16.546 33.6739 16.546C34.5508 16.546 35.2615 17.243 35.2615 18.103V19.6594ZM35.2611 38.3419C37.0139 38.34 38.4343 36.947 38.4362 35.228C38.4343 33.5095 37.0139 32.1165 35.2611 32.1146H25.736V38.3419H35.2611ZM25.736 22.7733V29.0007H35.2611C37.0148 29.0007 38.4362 27.6067 38.4362 25.8872C38.4362 24.1673 37.0148 22.7733 35.2611 22.7733H25.736Z",
    fill: "url(#paint0_linear_1682_546)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1682_546",
    x1: 30.4991,
    y1: -2.21744e-8,
    x2: 30.4972,
    y2: 62.8409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070430"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFt08);
export default __webpack_public_path__ + "static/media/ft_08.30e0277832cfc63c3a0aba4d6286e834.svg";
export { ForwardRef as ReactComponent };